import React from 'react';

interface State {
  error: Error | null;
}

/**
 * 관리자 대시보드 전용 에러 바운더리 — 렌더 크래시 시 흰 화면 대신
 * 오류 내용과 새로고침 버튼을 보여준다. (실사례: stats 응답 계약 불일치로
 * 대시보드가 통째로 빈 화면이 되어 원인 파악이 지연됨)
 */
export default class AdminErrorBoundary extends React.Component<React.PropsWithChildren, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error('[ADMIN] 대시보드 렌더 오류:', error, info.componentStack);
  }

  render() {
    if (this.state.error) {
      return (
        <div className="max-w-xl mx-auto mt-16 border border-gray-200 rounded-xl p-8 text-center">
          <h2 className="text-lg font-semibold text-gray-900 mb-2">관리자 대시보드 오류</h2>
          <p className="text-sm text-gray-500 mb-1">화면을 그리는 중 문제가 발생했습니다.</p>
          <p className="text-xs text-gray-400 mb-6 font-mono break-all">{this.state.error.message}</p>
          <button
            onClick={() => window.location.reload()}
            className="px-4 py-2 bg-gray-900 text-white rounded-lg hover:bg-gray-700 text-sm"
          >
            새로고침
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
